<template>
    <div>
        <div class="container container-fluid">
            <h1 class="page-heading">Video</h1>
        </div>

        <aha-video></aha-video>
    </div>
</template>

<script>
    import Vue from 'vue';
    import videoComponent from 'demo/components/video.vue';

    Vue.component('aha-video', videoComponent);
</script>



// WEBPACK FOOTER //
// demo/pages/components/video.vue